/* eslint-disable no-unused-vars */
import React from 'react';
import colors from '../modules/colors';

const StoryContext = React.createContext({
  primaryColor: colors.green,
  darkColor: colors.darkGreen,
  lightColor: colors.lightGreen,
  secondaryColor: colors.darkGrey,
  contrastColor: colors.grey,
  messageBackgroundColor: colors.taupe,
  selectionColor: colors.lightPurple,
  hoverColor: colors.lightYellow,
  noDataColor: colors.taupe,
  selectedState: null,
  setSelectedState: (state) => { },
});

export default StoryContext;
